import { smaTheme, isonTheme, defaultTheme, lichtblickTheme } from "./themes";

export type ThemeName = "sma" | "default" | "lichtblick" | "ison";

export enum ThemeValues {
  SMA = "sma",
  ison = "ison",
  default = "default",
  lichtblick = "lichtblick",
}

export const THEMES = {
  sma: smaTheme,
  ison: isonTheme,
  default: defaultTheme,
  lichtblick: lichtblickTheme,
};
